import React, { FC, useState } from 'react';
import { FaStar } from 'react-icons/fa';
import { useModal } from 'store/modal';
import { useHistory } from 'react-router';
import { useTranslation } from 'react-i18next';

import { useWorkModeContext } from 'store/work-mode';
import Button from 'components/Button';
import API from 'core/Api';
import { setAuthTokensFromResponse } from 'utils/auth';
import { updateUserData } from 'utils/userDataSync';
import { usePermissionsContext } from 'store/permissions';

interface IProps {
  hideMenu: () => void;
}
const ClientWorkMode: FC<IProps> = ({ hideMenu }) => {
  const { workMode, workModeName, altWorkModeName, setWorkMode, setWorkModeName, setAltWorkModeName } =
    useWorkModeContext();
  const [loading, setLoading] = useState(false);

  const history = useHistory();
  const { showModal } = useModal();

  const { setPermissions } = usePermissionsContext();

  const { t } = useTranslation();

  const toggleWorkMode = () => {
    setLoading(true);
    API.post('auth/work-mode-change')
      .then(res => setAuthTokensFromResponse(res))
      .then(() => API.get('permissions'))
      .then(res => {
        setPermissions(res.data);
      })
      .then(() =>
        updateUserData({
          setWorkMode: mode => setWorkMode(mode, history),
          setWorkModeName,
          setAltWorkModeName,
          onSuccess: data => {
            // Show success switched mode message
            showModal({
              type: 'success',
              content: (
                <>
                  {t('common.switchedMode')}&nbsp;
                  <span className="font-weight-bold">{data.work_mode_name}</span>.
                </>
              ),
            });
            hideMenu();
          },
        })
      )
      .catch(err => {
        showModal({
          type: 'error',
          content: err,
        });
      });
  };

  if (altWorkModeName)
    return (
      <>
        <p className="text-center">
          {t('menu.workMode')}
          <span className={`font-weight-bolder ${workMode === 'employer' ? 'text-secondary' : 'text-primary'}`}>
            {workModeName}
          </span>
        </p>
        <Button
          onClick={toggleWorkMode}
          className="mb-3"
          btnType={workMode === 'employer' ? 'primary' : 'secondary'}
          disabled={loading}
          loading={loading}
        >
          {`${t('menu.switchWorkMode')}${altWorkModeName} `}
          {workMode === 'employee' && (
            <FaStar
              className="ml-1"
              size={12}
            />
          )}
        </Button>
      </>
    );
  return null;
};

export default ClientWorkMode;
